import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import QUERIES, { Main } from '../theming/styles';
import styled, { createGlobalStyle } from 'styled-components';
import { Nav } from '../components';
import { SiteFooter } from '../components/foot/SiteFooter';
import { Spread } from '../components/switch/styles';
import OutlineDira from '../components/OutlineDira';
import ZoomImg from '../components/ZoomImg';
import DiraCover from '../images/dira/dira-cover-image.png';
import DiraChallange from '../images/dira/dira_challange.png';
import DiraFoundation from '../images/dira/foundation_dira.avif';
import DiraFoundationPng from '../images/dira/dira_foundation.png';
import TokensSite from '../images/dira/tokens_site.png';
import ColorsDira from '../images/dira/colors_dira.png';
import DiraTypo from '../images/dira/dira_typo.png';
import DiraIcons from '../images/dira/dira_icons.png';
import SpacingDira from '../images/dira/Spacing_dira.png';
import DiraComponents from '../images/dira/dira_components.png';
import DiraVariant from '../images/dira/Dira_variant.mp4';
import DiraBoolean from '../images/dira/dira_boolean.mp4';
import DiraAtoms from '../images/dira/dira_atoms.png';
import DiraComponentExample from '../images/dira/dira_component_example.mp4';
import PrincipleAesthetics from '../images/dira/aesthetics-principle 1.svg';
import PrincipleGestalt from '../images/dira/gestalt-principle.svg';
import PrincipleCognitive from '../images/dira/light-cognitive-load-principle.svg';
import PrincipleVisual from '../images/dira/visual-hierarchy-principle.svg';
import PrincipleConsistency from '../images/dira/consistency-principle.svg';
import PrincipleAdaptability from '../images/dira/adaptabilityy-principle.svg';
import DubiPreview from '../images/dubi/dub-preview.png';
import SchedulePreview from '../images/schedule/Frame 112539.png';

const DiraWalkthrough = 'https://0kealv3eq49t4p3r.public.blob.vercel-storage.com/Dira_wlaktrough_20252.mp4';

const BackLink = styled(Link)`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-family: var(--font-body);
    font-size: 14px;
    color: ${({ theme }) => theme.textMain};
    opacity: 0.5;
    margin-bottom: 32px;
    transition: opacity 0.15s ease;
    &:hover { opacity: 1; }
`;

const GlobalStyle = createGlobalStyle`
  html { scroll-behavior: smooth; }
`;

const CaseHeader = styled.div`
    max-width: 1200px;
    margin: 0 auto;
`;

const FlexGroup = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 30px;
    flex-wrap: wrap;

    div {
        width: 100%;
        @media (${QUERIES.medium}) { width: 45%; }
    }

    @media (${QUERIES.large}) {
        flex-wrap: nowrap;
        gap: 50px;
    }
`;

const PageLayout = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: flex-start;
    padding: 0 20px;
`;

const NavColumn = styled.div`
    width: 18%;
    flex-shrink: 0;
    position: sticky;
    top: 90px;
    align-self: flex-start;
    padding-top: 52px;

    @media (max-width: 1099px) {
        display: none;
    }
`;

const ContentColumn = styled.div`
    flex: 1;
    min-width: 0;

    h4 {
        font-weight: 500;
    }
`;

const Tag = styled.span`
    display: inline-block;
    background: var(--color-primary-10);
    color: var(--color-primary);
    border-radius: 100px;
    padding: 4px 14px;
    font-size: 11.5px;
    font-weight: 600;
    font-family: var(--font-body);
    margin-right: 8px;
    margin-bottom: 8px;
`;

const PhaseCard = styled.div`
    flex: 1;
    background: var(--color-bg);
    border-radius: 14px;
    padding: 24px;
`;

const ImpactStat = styled.div`
    background: var(--color-surface);
    border-radius: 16px;
    padding: clamp(20px,3vw,28px) clamp(16px,2.5vw,24px);
`;

const ImgPlaceholder = styled.div`
    width: 100%;
    background: var(--color-surface);
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 24px;
    gap: 10px;
    min-height: ${({ $h }) => $h || '320px'};
    margin: ${({ $m }) => $m || '0'};
    overflow: hidden;
`;

const ImgPlaceholderLabel = styled.p`
    font-family: var(--font-body);
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    opacity: 0.3;
    margin: 0;
    text-align: center;
`;

const CASE_STUDIES = [
    {
        tags: ['Product Design', 'Safaricom PLC'],
        title: 'Dubi — Turning Scattered Feedback Into Data-Driven Decisions',
        desc: 'A unified survey platform driving 92M+ engagements and 4× faster decisions across Kenya and Ethiopia.',
        href: '/dubi',
        preview: DubiPreview,
    },
    {
        tags: ['UX Design', 'Safaricom PLC'],
        title: 'My Safaricom Partner Portal — Unifying 5 Fragmented Portals',
        desc: 'One scalable SaaS platform for 4,700+ dealers, driving 90M KES in orders within the first month.',
        href: '/partner-portal',
        preview: SchedulePreview,
    },
];

const BrowserCard = ({ cs }) => (
    <div className="browser-card" style={{
        background: '#fff',
        borderRadius: 20,
        padding: '32px',
        display: 'flex',
        gap: 32,
        alignItems: 'stretch',
        minHeight: 340,
        boxSizing: 'border-box',
        boxShadow: '0 8px 40px rgba(0,0,0,0.10), 0 2px 8px rgba(0,0,0,0.06)',
    }}>
        <div className="browser-mockup" style={{
            flex: '0 0 45%',
            background: '#fff',
            borderRadius: 12,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            boxShadow: '0 4px 24px rgba(0,0,0,0.09)',
        }}>
            <div style={{
                background: '#f0f0f0',
                padding: '9px 12px',
                display: 'flex',
                alignItems: 'center',
                gap: 5,
                borderBottom: '1px solid #e5e5e5',
                flexShrink: 0,
            }}>
                <span style={{ width: 10, height: 10, borderRadius: '50%', background: '#ff5f57', display: 'inline-block' }} />
                <span style={{ width: 10, height: 10, borderRadius: '50%', background: '#febc2e', display: 'inline-block' }} />
                <span style={{ width: 10, height: 10, borderRadius: '50%', background: '#28c840', display: 'inline-block' }} />
                <div style={{ flex: 1, marginLeft: 8, background: '#e2e2e2', borderRadius: 5, height: 20, display: 'flex', alignItems: 'center', paddingLeft: 8 }}>
                    <span style={{ fontSize: 9, opacity: 0.5, fontFamily: 'var(--font-body)', letterSpacing: 0 }}>kimanigodfrey.bio{cs.href}</span>
                </div>
            </div>
            <div style={{ flex: 1, overflow: 'hidden', position: 'relative' }}>
                {cs.preview && (
                    <img src={cs.preview} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'top', display: 'block' }} />
                )}
            </div>
        </div>
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 16 }}>
            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
                <span style={{ background: 'rgba(3,14,73,0.1)', color: '#030e49', borderRadius: 100, padding: '4px 14px', fontSize: 11.5, fontWeight: 600, fontFamily: 'var(--font-body)' }}>{cs.tags[0]}</span>
                <span style={{ fontSize: 12, opacity: 0.4, fontFamily: 'var(--font-body)' }}>{cs.tags[1]}</span>
            </div>
            <h3 style={{ margin: 0, lineHeight: 1.2, fontSize: 'clamp(16px,2vw,22px)' }}>{cs.title}</h3>
            <p className="text-style" style={{ margin: 0, fontSize: 13 }}>{cs.desc}</p>
            <a href={cs.href} className="btn-primary">
                Read case study
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </a>
        </div>
    </div>
);

const MoreCaseStudies = () => {
    const [order, setOrder] = useState([0, 1]);
    const shuffle = () => setOrder(prev => [...prev.slice(1), prev[0]]);
    const OFFSET_Y = 46;
    const SCALE_STEP = 0.04;
    const numCards = order.length;
    const peekHeight = (numCards - 1) * OFFSET_Y;

    return (
        <div className="case-deck-wrap" style={{ background: 'var(--color-surface)', borderRadius: 24, padding: '50px' }}>
            <div style={{ position: 'relative', paddingTop: peekHeight }}>
                <div style={{ visibility: 'hidden', pointerEvents: 'none' }}>
                    <BrowserCard cs={CASE_STUDIES[0]} />
                </div>
                {order.map((csIdx, stackPos) => {
                    const ty = -stackPos * OFFSET_Y;
                    const scale = 1 - stackPos * SCALE_STEP;
                    const zIdx = numCards - stackPos;
                    return (
                        <div key={csIdx} style={{
                            position: 'absolute', top: peekHeight, left: 0, right: 0, zIndex: zIdx,
                            transform: `translateY(${ty}px) scale(${scale})`,
                            transformOrigin: 'bottom center',
                            transition: 'transform 400ms ease-out',
                        }}>
                            <BrowserCard cs={CASE_STUDIES[csIdx]} />
                        </div>
                    );
                })}
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 32 }}>
                <button onClick={shuffle} className="btn-text">
                    Shuffle
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginLeft: 6 }}><polyline points="16 3 21 3 21 8"/><line x1="4" y1="20" x2="21" y2="3"/><polyline points="21 16 21 21 16 21"/><line x1="4" y1="4" x2="9" y2="9"/></svg>
                </button>
            </div>
        </div>
    );
};

const IMPACT_PASSWORD = 'dira2025';

const LockedMetrics = () => {
    const [unlocked, setUnlocked] = useState(false);
    const [showPrompt, setShowPrompt] = useState(false);
    const [input, setInput] = useState('');
    const [error, setError] = useState(false);

    const stats = [
        { num: '35%', label: 'Faster', body: 'design-to-development handoffs with fewer back-and-forth cycles' },
        { num: '40%', label: 'Fewer', body: 'UI inconsistencies flagged in design reviews across sprints' },
    ];

    const tryUnlock = () => {
        if (input === IMPACT_PASSWORD) {
            setUnlocked(true);
            setShowPrompt(false);
            setError(false);
        } else {
            setError(true);
            setInput('');
        }
    };

    return (
        <div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 12 }}>
                {stats.map(({ num, label, body }) => (
                    <ImpactStat key={label}>
                        {/* Blurred real number + lock icon */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
                            <p style={{
                                fontFamily: 'var(--font-display)',
                                fontSize: 'clamp(22px,3vw,36px)',
                                fontWeight: 700,
                                color: 'var(--color-primary)',
                                margin: 0,
                                letterSpacing: 0,
                                filter: unlocked ? 'none' : 'blur(8px)',
                                userSelect: unlocked ? 'auto' : 'none',
                                transition: 'filter 0.4s ease',
                            }}>{num}</p>
                            {!unlocked && (
                                <button
                                    onClick={() => setShowPrompt(true)}
                                    title="View confidential metrics"
                                    style={{
                                        background: 'none', border: 'none', padding: 4, cursor: 'pointer',
                                        color: 'var(--color-primary)', opacity: 0.5, flexShrink: 0,
                                        display: 'flex', alignItems: 'center',
                                        transition: 'opacity 0.15s ease',
                                    }}
                                    onMouseEnter={e => e.currentTarget.style.opacity = 1}
                                    onMouseLeave={e => e.currentTarget.style.opacity = 0.5}
                                >
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                                </button>
                            )}
                        </div>
                        {/* Softened label always visible */}
                        <p style={{
                            fontFamily: 'var(--font-display)',
                            fontSize: 'clamp(18px,2.5vw,28px)',
                            fontWeight: 700,
                            color: 'var(--color-primary)',
                            margin: '0 0 8px',
                            letterSpacing: 0,
                            opacity: unlocked ? 0.3 : 1,
                            transition: 'opacity 0.4s ease',
                        }}>{label}</p>
                        <p className="text-style" style={{ margin: 0, fontSize: 'clamp(12px,1.4vw,14px)' }}>{body}</p>
                    </ImpactStat>
                ))}
            </div>

            {unlocked && (
                <div style={{ marginTop: 12, display: 'flex', alignItems: 'center', gap: 6, opacity: 0.4 }}>
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 9.9-1"/></svg>
                    <span style={{ fontFamily: 'var(--font-body)', fontSize: 12 }}>Confidential metrics unlocked</span>
                </div>
            )}

            {/* Password modal */}
            {showPrompt && (
                <div
                    onClick={() => { setShowPrompt(false); setError(false); setInput(''); }}
                    style={{
                        position: 'fixed', inset: 0, zIndex: 9999,
                        background: 'rgba(0,0,0,0.55)', backdropFilter: 'blur(4px)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                    }}
                >
                    <div
                        onClick={e => e.stopPropagation()}
                        style={{
                            background: 'var(--color-bg)', borderRadius: 20, padding: '36px 40px',
                            width: '100%', maxWidth: 400, boxShadow: '0 24px 60px rgba(0,0,0,0.25)',
                            display: 'flex', flexDirection: 'column', gap: 20,
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                            <div style={{
                                width: 40, height: 40, borderRadius: 10,
                                background: 'var(--color-surface)',
                                display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                            }}>
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                            </div>
                            <div>
                                <p style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 16, margin: 0, color: 'var(--color-text)' }}>Confidential metrics</p>
                                <p style={{ fontFamily: 'var(--font-body)', fontSize: 13, opacity: 0.5, margin: 0 }}>Enter password to view</p>
                            </div>
                        </div>

                        <input
                            type="password"
                            value={input}
                            onChange={e => { setInput(e.target.value); setError(false); }}
                            onKeyDown={e => e.key === 'Enter' && tryUnlock()}
                            placeholder="Password"
                            autoFocus
                            style={{
                                fontFamily: 'var(--font-body)', fontSize: 14, padding: '12px 16px',
                                borderRadius: 12, border: `1.5px solid ${error ? '#e53935' : 'var(--color-border, rgba(0,0,0,0.12))'}`,
                                background: 'var(--color-surface)', color: 'var(--color-text)',
                                outline: 'none', width: '100%', boxSizing: 'border-box',
                            }}
                        />
                        {error && <p style={{ margin: '-12px 0 0', fontSize: 12, color: '#e53935', fontFamily: 'var(--font-body)' }}>Incorrect password — try again</p>}

                        <div style={{ display: 'flex', gap: 10 }}>
                            <button onClick={tryUnlock} className="btn-primary" style={{ flex: 1, justifyContent: 'center' }}>
                                Unlock
                            </button>
                            <button
                                onClick={() => { setShowPrompt(false); setError(false); setInput(''); }}
                                style={{
                                    fontFamily: 'var(--font-body)', fontSize: 13, fontWeight: 500,
                                    background: 'var(--color-surface)', border: 'none', borderRadius: 100,
                                    padding: '12px 20px', cursor: 'pointer', color: 'var(--color-text)', opacity: 0.7,
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

const Dira = ({ toggleMode, mode, spread, setDisableScroll }) => {
    const [modal, setModal] = useState(null); // { src, bg? }
    const spreadClass =
        spread === 'first' ? 'growBlack' : spread === 'second' ? 'growWhite' : '';

    return (
        <Main style={{
            position: 'relative',
            overflow: setDisableScroll ? 'hidden' : 'null',
            height: setDisableScroll ? '100vh' : 'unset',
        }}>
            <GlobalStyle />
            <Spread className={spreadClass} />
            <Nav mode={mode} toggleMode={toggleMode} />

            <PageLayout>
                <NavColumn>
                    <OutlineDira />
                </NavColumn>
                <ContentColumn>

                    {/* ── HERO ── */}
                    <CaseHeader id="summary" className="card-pad" style={{ maxWidth: 'none', margin: 0 }}>
                        <BackLink to="/">← Back</BackLink>
                        <Tag>Design Systems</Tag>
                        <Tag>Safaricom PLC</Tag>
                        <h2 style={{ marginTop: 20, marginBottom: 20 }}>
                            Enabling 100+ designers &amp; developers to ship cohesive experiences faster.
                        </h2>
                        <p className="text-style" style={{ marginBottom: 32, maxWidth: 680 }}>
                            As new products launched, the design system required evolution. The Dira rebuild improved component libraries and foundational elements to establish a more cohesive and scalable system — driving consistency, efficiency, and seamless collaboration between design and development.
                        </p>

                        {/* ── Summary cards ── */}
                        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', background: 'var(--color-surface)', borderRadius: 18, padding: 8, margin: '32px 0' }}>
                            {/* Key Results */}
                            <div style={{ flex: 1, minWidth: 180, background: 'var(--color-bg)', borderRadius: 12, padding: 20 }}>
                                <div style={{ color: 'var(--color-text)', marginBottom: 20, opacity: 0.6 }}>
                                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                                        <polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
                                    </svg>
                                </div>
                                <h5 style={{ marginBottom: 10 }}>Key Results</h5>
                                {[
                                    '90% component reuse rate across products.',
                                    '35% reduction in design-to-development handoff time.',
                                    '100% of design & engineering teams adopted within 2 months.',
                                ].map(item => (
                                    <div key={item} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 8 }}>
                                        <svg width="18" height="18" viewBox="0 0 20 20" fill="none" style={{ flexShrink: 0, marginTop: 2 }}>
                                            <circle cx="10" cy="10" r="9" stroke="currentColor" strokeWidth="1.5" opacity="0.4"/>
                                            <path d="M6.5 10.5l2.5 2.5 4.5-4.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                        <p className="text-style" style={{ margin: 0 }}>{item}</p>
                                    </div>
                                ))}
                            </div>

                            {/* Timeline */}
                            <div style={{ flex: 1, minWidth: 140, background: 'var(--color-bg)', borderRadius: 12, padding: 20 }}>
                                <div style={{ color: 'var(--color-text)', marginBottom: 20, opacity: 0.6 }}>
                                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
                                    </svg>
                                </div>
                                <h5 style={{ marginBottom: 10 }}>Timeline</h5>
                                {[
                                    { year: '2024,', label: 'Audit & Discovery' },
                                    { year: '2024,', label: 'Design & Build' },
                                    { year: '2025,', label: 'Launch & Adoption' },
                                ].map(({ year, label }) => (
                                    <p key={label} className="text-style" style={{ margin: '0 0 6px' }}>
                                        <strong style={{ opacity: 1 }}>{year}</strong> <span style={{ opacity: 0.55 }}>{label}</span>
                                    </p>
                                ))}
                            </div>

                            {/* Role */}
                            <div style={{ flex: 1, minWidth: 160, background: 'var(--color-bg)', borderRadius: 12, padding: 20 }}>
                                <div style={{ color: 'var(--color-text)', marginBottom: 20, opacity: 0.6 }}>
                                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                                        <rect x="2" y="7" width="20" height="14" rx="2" ry="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
                                    </svg>
                                </div>
                                <h5 style={{ marginBottom: 10 }}>My Role</h5>
                                <p className="text-style" style={{ margin: '0 0 8px' }}>Lead Product Designer<br/>End-to-End Design</p>
                                <p className="text-style" style={{ margin: '0 0 16px', fontSize: 14, opacity: 0.7 }}>I led the design end to end: audit, components, tokens and documentation. Alex Karanja (UX Lead) reviewed direction; engineering built it.</p>
                                <h5 style={{ marginBottom: 8 }}>Methods</h5>
                                <p className="text-style" style={{ margin: 0 }}>
                                    System Audit / Component Design / Token Architecture / Design Governance / Stakeholder Workshops
                                </p>
                            </div>
                        </div>
                    </CaseHeader>

                    {/* ── HERO COVER IMAGE ── */}
                    <div className="card-pad" style={{ marginBottom: 0, paddingTop: 0 }}>
                        <p style={{ fontSize: 11, fontWeight: 600, letterSpacing: '1.5px', textTransform: 'uppercase', opacity: 0.45, marginBottom: 16 }}>
                            👇 A Glimpse of Dira
                        </p>
                        <div style={{ background: 'var(--color-surface)', borderRadius: 16, padding: 16 }}>
                            <ZoomImg
                                src={DiraCover}
                                alt="Dira design system cover"
                                onClick={() => setModal({ src: DiraCover, bg: 'var(--color-surface)' })}
                                radius="10px"
                            />
                            <p style={{ fontSize: 13, opacity: 0.5, textAlign: 'center', margin: '12px 0 0' }}>An overview of the Dira design system — components, tokens, and documentation</p>
                        </div>
                    </div>

                    {/* ── A GLIMPSE OF DIRA ── */}
                    <div className="card-pad" style={{ marginBottom: 0 }}>
                        <h3 style={{ margin: '0 0 12px' }}>A full walkthrough of Dira in action.</h3>
                        <p className="text-style" style={{ marginBottom: 24, maxWidth: 680 }}>
                            The highlight video shows a full walkthrough of Dira presented to the tech team with Chris. The session demonstrated how teams use Dira for design implementation, handoff, and translation of documented components into the code base.
                        </p>
                        <video
                            src={DiraWalkthrough}
                            controls
                            style={{
                                width: '100%',
                                borderRadius: 16,
                                display: 'block',
                                background: '#000',
                            }}
                        />
                        <p style={{ fontSize: 13, opacity: 0.5, textAlign: 'center', margin: '12px 0 0' }}>Full walkthrough of Dira presented to the tech team — design implementation, handoff, and component translation</p>
                    </div>

                    {/* ── PROBLEM ── */}
                    <div id="problem" className="card-pad" style={{ marginBottom: 0 }}>
                        <p style={{ fontSize: 11, fontWeight: 600, letterSpacing: '1.5px', textTransform: 'uppercase', opacity: 0.45, marginBottom: 16 }}>
                            The Problem
                        </p>
                        <h3 style={{ margin: '0 0 20px' }}>Shipping was slow. Designs were inconsistent. Handoffs were painful.</h3>
                        <p className="text-style" style={{ marginBottom: 32, maxWidth: 680 }}>
                            As Safaricom scaled across multiple products and markets, fragmentation crept in. Components were duplicated, patterns diverged, and every handoff became a negotiation. <mark>This fragmentation slowed us down and diluted the brand experience.</mark>
                        </p>

                        <div style={{ background: 'var(--color-surface)', borderRadius: 20, padding: 12, display: 'flex', flexDirection: 'column', gap: 10 }}>
                            {/* Image on top */}
                            <ZoomImg
                                src={DiraChallange}
                                alt="Dira challenge overview"
                                onClick={() => setModal({ src: DiraChallange })}
                                radius="12px"
                            />
                            <p style={{ fontSize: 13, opacity: 0.5, textAlign: 'center', margin: '2px 0 6px' }}>Fragmentation across products — inconsistent patterns and duplicated components</p>
                            {/* 2×2 grid below */}
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                                {[
                                    { title: 'Inconsistent UI patterns', body: 'Components varied across products with no shared source of truth.' },
                                    { title: 'Repeated design work', body: 'Teams re-created the same elements independently, wasting effort.' },
                                    { title: 'Painful handoffs', body: 'Developers received incomplete or conflicting specs on every sprint.' },
                                    { title: 'Longer release cycles', body: 'Rework and QA issues extended timelines and delayed launches.' },
                                ].map(({ title, body }) => (
                                    <div key={title} style={{ background: '#fff', borderRadius: 14, padding: '20px' }}>
                                        <h4 style={{ margin: '0 0 6px', fontSize: 15 }}>{title}</h4>
                                        <p className="text-style" style={{ margin: 0, fontSize: 13 }}>{body}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* ── DESIGN PROCESS ── */}
                    <div id="discovery" className="card-pad" style={{ marginBottom: 0 }}>
                        <p style={{ fontSize: 11, fontWeight: 600, letterSpacing: '1.5px', textTransform: 'uppercase', opacity: 0.45, marginBottom: 16 }}>
                            Design Process
                        </p>
                        <h3 style={{ margin: '0 0 12px' }}>Discover. Develop. Deliver.</h3>
                        <p className="text-style" style={{ marginBottom: 28, maxWidth: 680 }}>
                            Every problem demands something new. Rather than applying a generic framework, the approach was shaped by the specific gaps uncovered in the audit.
                        </p>

                        <div style={{ display: 'flex', gap: 8, background: 'var(--color-surface)', borderRadius: 18, padding: 8 }}>
                            {[
                                {
                                    num: '01',
                                    title: 'Discover',
                                    body: 'Defined problems using evidence of inconsistent designs. Reviewed existing products and audited interaction patterns across all platforms.',
                                },
                                {
                                    num: '02',
                                    title: 'Develop',
                                    body: 'Created component requirements from audit findings. Built early drafts in Figma with clear usage rules. Tested through short, iterative review cycles.',
                                },
                                {
                                    num: '03',
                                    title: 'Deliver',
                                    body: 'Published the Dira library with tokens, components, and guidelines. Conducted training sessions and handovers to drive adoption.',
                                },
                            ].map(({ num, title, body }) => (
                                <PhaseCard key={num} style={{ flexDirection: 'column' }}>
                                    <p style={{ fontFamily: 'var(--font-display)', fontSize: 32, fontWeight: 700, color: 'var(--color-primary)', opacity: 0.2, margin: '0 0 12px', lineHeight: 1 }}>{num}</p>
                                    <h4 style={{ margin: '0 0 10px' }}>{title}</h4>
                                    <p className="text-style" style={{ margin: 0, fontSize: 13 }}>{body}</p>
                                </PhaseCard>
                            ))}
                        </div>

                        {/* Foundation image */}
                        <div style={{ marginTop: 16, background: 'var(--color-surface)', borderRadius: 16, padding: 16 }}>
                            <ZoomImg
                                src={DiraFoundation}
                                alt="Dira foundation overview"
                                onClick={() => setModal({ src: DiraFoundation, bg: 'var(--color-surface)' })}
                                radius="12px"
                            />
                            <p style={{ fontSize: 13, opacity: 0.5, textAlign: 'center', margin: '12px 0 0' }}>Dira system structure — Foundation, Shared Components, Mobile &amp; Web Assets, Templates</p>
                        </div>
                    </div>

                    {/* ── USER PERSONAS ── */}
                    <div className="card-pad" style={{ marginBottom: 0 }}>
                        <p style={{ fontSize: 11, fontWeight: 600, letterSpacing: '1.5px', textTransform: 'uppercase', opacity: 0.45, marginBottom: 16 }}>
                            Who We Designed For
                        </p>
                        <h3 style={{ margin: '0 0 12px' }}>Two primary users. One shared frustration.</h3>
                        <p className="text-style" style={{ marginBottom: 28, maxWidth: 680 }}>
                            The design system needed to serve both designers building experiences and engineers shipping them — with different workflows but the same need for clarity.
                        </p>

                        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
                            {[
                                {
                                    role: 'Designer',
                                    painPoints: [
                                        'Inconsistent components and interaction patterns across products',
                                        'Unclear naming and documentation causing delays',
                                    ],
                                    needs: ['Unified, easy-to-use component library', 'Clear guidelines and usage rules'],
                                    goals: ['Maintain design consistency', 'Improve team efficiency', 'Deliver high-quality products'],
                                },
                                {
                                    role: 'Frontend Engineer',
                                    painPoints: [
                                        'Designers use components differently across teams',
                                        'Missing or incomplete documentation delays development',
                                    ],
                                    needs: ['Standardized components with code-ready specs', 'Clear design tokens and interaction rules'],
                                    goals: ['Receive predictable, consistent designs', 'Reduce time spent clarifying UI details'],
                                },
                            ].map(({ role, painPoints, needs, goals }) => (
                                <div key={role} style={{ flex: 1, minWidth: 260, background: 'var(--color-surface)', borderRadius: 16, padding: 28 }}>
                                    <h4 style={{ margin: '0 0 20px' }}>{role}</h4>

                                    <p style={{ fontFamily: 'var(--font-body)', fontSize: 11, fontWeight: 600, letterSpacing: '0.8px', textTransform: 'uppercase', opacity: 0.45, margin: '0 0 10px' }}>Pain Points</p>
                                    {painPoints.map(p => (
                                        <div key={p} style={{ display: 'flex', gap: 10, marginBottom: 8 }}>
                                            <span style={{ flexShrink: 0, width: 8, height: 8, borderRadius: '50%', background: '#ef4444', marginTop: 7 }} />
                                            <p className="text-style" style={{ margin: 0, fontSize: 13 }}>{p}</p>
                                        </div>
                                    ))}

                                    <p style={{ fontFamily: 'var(--font-body)', fontSize: 11, fontWeight: 600, letterSpacing: '0.8px', textTransform: 'uppercase', opacity: 0.45, margin: '16px 0 10px' }}>Needs</p>
                                    {needs.map(n => (
                                        <div key={n} style={{ display: 'flex', gap: 10, marginBottom: 8 }}>
                                            <span style={{ flexShrink: 0, width: 8, height: 8, borderRadius: '50%', background: 'var(--color-primary)', marginTop: 7 }} />
                                            <p className="text-style" style={{ margin: 0, fontSize: 13 }}>{n}</p>
                                        </div>
                                    ))}

                                    <p style={{ fontFamily: 'var(--font-body)', fontSize: 11, fontWeight: 600, letterSpacing: '0.8px', textTransform: 'uppercase', opacity: 0.45, margin: '16px 0 10px' }}>Goals</p>
                                    {goals.map(g => (
                                        <div key={g} style={{ display: 'flex', gap: 10, marginBottom: 8 }}>
                                            <span style={{ flexShrink: 0, width: 8, height: 8, borderRadius: '50%', background: '#22c55e', marginTop: 7 }} />
                                            <p className="text-style" style={{ margin: 0, fontSize: 13 }}>{g}</p>
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* ── SYSTEM GOALS + DESIGN PRINCIPLES ── */}
                    <div id="building-mvp" className="card-pad" style={{ marginBottom: 0 }}>
                        <p style={{ fontSize: 11, fontWeight: 600, letterSpacing: '1.5px', textTransform: 'uppercase', opacity: 0.45, marginBottom: 16 }}>
                            System Goals
                        </p>
                        <h3 style={{ margin: '0 0 12px' }}>What Dira needed to achieve.</h3>
                        <p className="text-style" style={{ marginBottom: 24, maxWidth: 680 }}>
                            Three goals guided every decision — from how we named tokens to how we structured component documentation.
                        </p>

                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 12, marginBottom: 40 }}>
                            {[
                                { num: '1', title: 'Visual Consistency', body: 'Standardize components, styles, and interactions to ensure a cohesive and polished user experience across all products.' },
                                { num: '2', title: 'Improve Efficiency', body: 'Streamline workflows, reduce redundancies, and enhance collaboration between design and engineering teams.' },
                                { num: '3', title: 'Flexible & Scalable', body: 'Build an adaptable system that supports evolving needs, new use cases, and future platform expansion.' },
                            ].map(({ num, title, body }) => (
                                <div key={num} style={{ background: 'var(--color-surface)', borderRadius: 16, padding: '24px 20px' }}>
                                    <p style={{ fontFamily: 'var(--font-display)', fontSize: 36, fontWeight: 700, color: 'var(--color-primary)', opacity: 0.15, margin: '0 0 8px', lineHeight: 1 }}>{num}</p>
                                    <h4 style={{ margin: '0 0 8px' }}>{title}</h4>
                                    <p className="text-style" style={{ margin: 0, fontSize: 13 }}>{body}</p>
                                </div>
                            ))}
                        </div>

                        <p style={{ fontSize: 11, fontWeight: 600, letterSpacing: '1.5px', textTransform: 'uppercase', opacity: 0.45, marginBottom: 16 }}>
                            Design Principles
                        </p>
                        <h4 style={{ margin: '0 0 20px' }}>The rules that guided component decisions.</h4>

                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12 }}>
                            {[
                                { icon: PrincipleAesthetics, title: 'Aesthetics', body: 'A polished UI enhances trust and reduces friction.' },
                                { icon: PrincipleGestalt, title: 'Gestalt approach', body: 'We use Gestalt principles for intuitive, coherent components.' },
                                { icon: PrincipleCognitive, title: 'Light cognitive load', body: 'Clear choices and structure enable effortless decisions.' },
                                { icon: PrincipleVisual, title: 'Visual hierarchy', body: 'Contrast, size, and spacing improve focus and scanning.' },
                                { icon: PrincipleConsistency, title: 'Consistency', body: 'Predictable patterns accelerate learning for seamless UX.' },
                                { icon: PrincipleAdaptability, title: 'Adaptability', body: 'Components evolve to support new cases with consistency.' },
                            ].map(({ icon, title, body }) => (
                                <div key={title} style={{ background: 'var(--color-surface)', borderRadius: 20, padding: '28px 24px' }}>
                                    <div style={{ width: 64, height: 64, borderRadius: 14, background: 'var(--color-icon-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 24 }}>
                                        <img src={icon} alt="" aria-hidden="true" style={{ width: 40, height: 40, objectFit: 'contain' }} />
                                    </div>
                                    <h4 style={{ margin: '0 0 10px' }}>{title}</h4>
                                    <p className="text-style" style={{ margin: 0, opacity: 0.6 }}>{body}</p>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* ── FOUNDATION ── */}
                    <div className="card-pad" style={{ marginBottom: 0 }}>
                        <p style={{ fontSize: 11, fontWeight: 600, letterSpacing: '1.5px', textTransform: 'uppercase', opacity: 0.45, marginBottom: 16 }}>
                            Foundation
                        </p>
                        <h3 style={{ margin: '0 0 12px' }}>Tokens, colours, type, icons — rebuilt from scratch.</h3>
                        <p className="text-style" style={{ marginBottom: 24, maxWidth: 680 }}>
                            Dedicated pages follow industry best practices with introductory sections providing context and content areas showcasing design assets and specifications.
                        </p>

                        {/* Foundation overview image */}
                        <div style={{ background: 'var(--color-surface)', borderRadius: 16, padding: 16, marginBottom: 40 }}>
                            <ZoomImg
                                src={DiraFoundationPng}
                                alt="Dira foundation — tokens, colours, typography, icons, spacing"
                                onClick={() => setModal({ src: DiraFoundationPng, bg: 'var(--color-surface)' })}
                                radius="10px"
                            />
                            <p style={{ fontSize: 13, opacity: 0.5, textAlign: 'center', margin: '12px 0 0' }}>Overview of the Dira foundation — tokens, colours, typography, icons, and spacing</p>
                        </div>

                        {/* Tokens */}
                        <div style={{ marginBottom: 40 }}>
                            <h4 style={{ margin: '0 0 8px' }}>Tokens</h4>
                            <p className="text-style" style={{ margin: '0 0 16px', fontSize: 14, maxWidth: 620 }}>
                                Improved the definition and structure of design tokens, making them more scalable and adaptable to the diverse needs of all products. This new system ensures consistency across the ecosystem while allowing flexibility to support future growth and evolving design requirements.
                            </p>
                            <div style={{ background: 'var(--color-surface)', borderRadius: 16, padding: 16 }}>
                                <ZoomImg
                                    src={TokensSite}
                                    alt="Dira design tokens overview"
                                    onClick={() => setModal({ src: TokensSite, bg: 'var(--color-surface)' })}
                                    radius="10px"
                                />
                                <p style={{ fontSize: 13, opacity: 0.5, textAlign: 'center', margin: '12px 0 0' }}>Design tokens — color mode variables mapped to light and dark</p>
                            </div>
                        </div>

                        {/* Colours */}
                        <div style={{ marginBottom: 40 }}>
                            <h4 style={{ margin: '0 0 8px' }}>Colours</h4>
                            <p className="text-style" style={{ margin: '0 0 16px', fontSize: 14, maxWidth: 620 }}>
                                Expanded and fine-tuned the colour palette to enhance contrast and ensure accessibility. Primary, secondary, semantic, and neutral colours are fully tokenised and mapped to both light and dark modes.
                            </p>
                            <div style={{ background: 'var(--color-surface)', borderRadius: 16, padding: 16 }}>
                                <ZoomImg
                                    src={ColorsDira}
                                    alt="Dira colour tokens — light and dark values"
                                    onClick={() => setModal({ src: ColorsDira, bg: 'var(--color-surface)' })}
                                    radius="10px"
                                />
                                <p style={{ fontSize: 13, opacity: 0.5, textAlign: 'center', margin: '12px 0 0' }}>Figma — colour tokens table with light &amp; dark values</p>
                            </div>
                        </div>

                        {/* Typography */}
                        <div style={{ marginBottom: 40 }}>
                            <h4 style={{ margin: '0 0 8px' }}>Typography</h4>
                            <p className="text-style" style={{ margin: '0 0 16px', fontSize: 14, maxWidth: 620 }}>
                                Introduced <strong>Proxima Nova</strong>, replacing Futura in many screens to reduce visual load and improve readability. Adjusted line height of certain styles for better text balance and clarity.
                            </p>
                            <div style={{ background: 'var(--color-surface)', borderRadius: 16, padding: 16 }}>
                                <ZoomImg
                                    src={DiraTypo}
                                    alt="Dira typography — variables and text styles"
                                    onClick={() => setModal({ src: DiraTypo, bg: 'var(--color-surface)' })}
                                    radius="10px"
                                />
                                <p style={{ fontSize: 13, opacity: 0.5, textAlign: 'center', margin: '12px 0 0' }}>Figma — typography variables &amp; text styles panel</p>
                            </div>
                        </div>

                        {/* Icons */}
                        <div style={{ marginBottom: 40 }}>
                            <h4 style={{ margin: '0 0 8px' }}>Icons</h4>
                            <p className="text-style" style={{ margin: '0 0 16px', fontSize: 14, maxWidth: 620 }}>
                                Added numerous new icons across 5 different styles. Redesigned existing ones with a 2px stroke, ensuring visual harmony with the lighter Medium weight typography and a more cohesive, balanced interface.
                            </p>
                            <div style={{ background: 'var(--color-surface)', borderRadius: 16, padding: 16 }}>
                                <ZoomImg
                                    src={DiraIcons}
                                    alt="Dira icon library — 5 styles grid"
                                    onClick={() => setModal({ src: DiraIcons, bg: 'var(--color-surface)' })}
                                    radius="10px"
                                />
                                <p style={{ fontSize: 13, opacity: 0.5, textAlign: 'center', margin: '12px 0 0' }}>Figma — icon library grid across 5 styles</p>
                            </div>
                        </div>

                        {/* Spacing */}
                        <div>
                            <h4 style={{ margin: '0 0 8px' }}>Spacing</h4>
                            <p className="text-style" style={{ margin: '0 0 16px', fontSize: 14, maxWidth: 620 }}>
                                Defined semantic spacing tokens achieving consistent rhythm across all areas of the app. Spacing is applied directly from variables, ensuring every component and layout uses the same underlying scale.
                            </p>
                            <div style={{ background: 'var(--color-surface)', borderRadius: 16, padding: 16 }}>
                                <ZoomImg
                                    src={SpacingDira}
                                    alt="Dira spacing tokens applied to component annotation"
                                    onClick={() => setModal({ src: SpacingDira, bg: 'var(--color-surface)' })}
                                    radius="10px"
                                />
                                <p style={{ fontSize: 13, opacity: 0.5, textAlign: 'center', margin: '12px 0 0' }}>Figma — spacing tokens applied to component annotation</p>
                            </div>
                        </div>

                        {/* Components Library */}
                        <h3 style={{ margin: '48px 0 8px' }}>Components library</h3>

                        {/* Organization */}
                        <div style={{ marginBottom: 40 }}>
                            <h4 style={{ margin: '0 0 8px' }}>Organization of the file</h4>
                            <p className="text-style" style={{ margin: '0 0 16px', fontSize: 14, maxWidth: 620 }}>
                                Our Component Library file is thoughtfully organized, with each page containing multiple components that belong to the same group. Each page is divided into two sections: one showcasing the atoms and components, and the other to the right, providing detailed documentation for each component within the group.
                            </p>
                            <div style={{ background: 'var(--color-surface)', borderRadius: 16, padding: 16 }}>
                                <ZoomImg
                                    src={DiraComponents}
                                    alt="Dira component library file organization"
                                    onClick={() => setModal({ src: DiraComponents, bg: 'var(--color-surface)' })}
                                    radius="10px"
                                />
                                <p style={{ fontSize: 13, opacity: 0.5, textAlign: 'center', margin: '12px 0 0' }}>Component library file — pages organized by component group</p>
                            </div>
                        </div>

                        {/* Good practices */}
                        <div style={{ marginBottom: 40 }}>
                            <h4 style={{ margin: '0 0 8px' }}>Good practices</h4>
                            <p className="text-style" style={{ margin: '0 0 16px', fontSize: 14, maxWidth: 620 }}>
                                Variants are fundamental in components, but analyzing their characteristics is crucial. Understanding which features can coexist helps define what should be a variant and what should be a boolean.
                            </p>
                            <div style={{ background: 'var(--color-surface)', borderRadius: 16, padding: 16, marginBottom: 16 }}>
                                <video
                                    src={DiraVariant}
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    style={{ width: '100%', borderRadius: 10, display: 'block' }}
                                />
                                <p style={{ fontSize: 13, opacity: 0.5, textAlign: 'center', margin: '12px 0 0' }}>Defining variants — what should be a variant vs. a boolean</p>
                            </div>
                            <p className="text-style" style={{ margin: '0 0 16px', fontSize: 14, maxWidth: 620 }}>
                                Using booleans is crucial for optimizing the number of variants in our components, as it enhances usability while simplifying maintenance and scalability.
                            </p>
                            <div style={{ background: 'var(--color-surface)', borderRadius: 16, padding: 16 }}>
                                <video
                                    src={DiraBoolean}
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    style={{ width: '100%', borderRadius: 10, display: 'block' }}
                                />
                                <p style={{ fontSize: 13, opacity: 0.5, textAlign: 'center', margin: '12px 0 0' }}>Boolean properties — reducing variant count while improving flexibility</p>
                            </div>
                        </div>

                        {/* Atoms */}
                        <div style={{ marginBottom: 40 }}>
                            <h3 style={{ margin: '0 0 8px' }}>_atoms</h3>
                            <p className="text-style" style={{ margin: '0 0 16px', fontSize: 14, maxWidth: 620 }}>
                                Atomic Design ensures a scalable, modular structure by breaking components into smaller parts, promoting consistency, reusability, and faster design and development.
                            </p>
                            <div style={{ background: 'var(--color-surface)', borderRadius: 16, padding: 16, marginBottom: 16 }}>
                                <ZoomImg
                                    src={DiraAtoms}
                                    alt="Dira atoms — atomic design structure"
                                    onClick={() => setModal({ src: DiraAtoms, bg: 'var(--color-surface)' })}
                                    radius="10px"
                                />
                                <p style={{ fontSize: 13, opacity: 0.5, textAlign: 'center', margin: '12px 0 0' }}>Atom library — foundational building blocks of the design system</p>
                            </div>
                            <p className="text-style" style={{ margin: '0 0 16px', fontSize: 14, maxWidth: 620 }}>
                                In the following example, you can see how the Metric-card component is built with atoms and the flexibility of adjusting the various atoms.
                            </p>
                            <div style={{ background: 'var(--color-surface)', borderRadius: 16, padding: 16 }}>
                                <video
                                    src={DiraComponentExample}
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    style={{ width: '100%', borderRadius: 10, display: 'block' }}
                                />
                                <p style={{ fontSize: 13, opacity: 0.5, textAlign: 'center', margin: '12px 0 0' }}>Metric-card built from atoms — demonstrating component flexibility</p>
                            </div>
                        </div>
                    </div>

                    {/* ── IMPACT ── */}
                    <div id="impact" className="card-pad" style={{ marginBottom: 0 }}>
                        <p style={{ fontSize: 11, fontWeight: 600, letterSpacing: '1.5px', textTransform: 'uppercase', opacity: 0.45, marginBottom: 16 }}>
                            Business Impact
                        </p>
                        <h3 style={{ margin: '0 0 12px' }}>What changed after launch.</h3>
                        <p className="text-style" style={{ marginBottom: 28, maxWidth: 680 }}>
                            Across the product org, designers and developers reported measurably smoother workflows within the first few months of adoption.
                        </p>

                        <LockedMetrics />
                    </div>

                    {/* ── TESTING & ADOPTION ── */}
                    <div className="card-pad" style={{ marginBottom: 0 }}>
                        <p style={{ fontSize: 11, fontWeight: 600, letterSpacing: '1.5px', textTransform: 'uppercase', opacity: 0.45, marginBottom: 16 }}>
                            Testing & Adoption
                        </p>
                        <h3 style={{ margin: '0 0 20px' }}>Piloted. Iterated. Scaled.</h3>
                        <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: 12 }}>
                            {[
                                { label: 'Pilot first', body: 'Rolled out to 2 product teams before scaling organisation-wide to catch edge cases early.' },
                                { label: 'Continuous feedback', body: 'Gathered input via design critiques and development syncs throughout the process.' },
                                { label: 'Real-world iteration', body: 'Iterated components based on real usage, not assumptions.' },
                                { label: 'Monthly releases', body: 'Shipped monthly updates for continuous improvement and new component additions.' },
                            ].map(({ label, body }) => (
                                <li key={label} style={{ display: 'flex', alignItems: 'flex-start', gap: 16, background: 'var(--color-surface)', borderRadius: 14, padding: '18px 20px' }}>
                                    <span style={{ flexShrink: 0, width: 8, height: 8, borderRadius: '50%', background: 'var(--color-primary)', marginTop: 7 }} />
                                    <div>
                                        <p style={{ fontFamily: 'var(--font-body)', fontWeight: 600, fontSize: 15, margin: '0 0 4px', color: 'var(--color-text)' }}>{label}</p>
                                        <p className="text-style" style={{ margin: 0, fontSize: 14 }}>{body}</p>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* ── NEXT STEPS ── */}
                    <div id="next-steps" className="card-pad" style={{ marginBottom: 0 }}>
                        <p style={{ fontSize: 11, fontWeight: 600, letterSpacing: '1.5px', textTransform: 'uppercase', opacity: 0.45, marginBottom: 16 }}>
                            Next Steps
                        </p>
                        <h3 style={{ margin: '0 0 20px' }}>What comes after launch.</h3>
                        <ul style={{ listStyle: 'none', margin: '20px 0 0', padding: 0, display: 'flex', flexDirection: 'column', gap: 12 }}>
                            {[
                                { label: 'Design Rules & Detaching Guidelines', body: 'Document when to follow system rules strictly versus when flexibility is acceptable.' },
                                { label: 'Onboarding Templates', body: 'Create starter kits and templates to accelerate onboarding for new team members.' },
                                { label: 'Governance Framework', body: 'Establish contribution workflows, approval processes, and regular audits to keep the system healthy.' },
                                { label: 'Cross-team Evangelism', body: 'Run study jams, showcases, and office hours to drive understanding and adoption.' },
                                { label: 'Scalability', body: 'Expand to motion design, accessibility standards, and cross-platform consistency.' },
                            ].map(({ label, body }) => (
                                <li key={label} style={{ display: 'flex', gap: 16, alignItems: 'flex-start', background: 'var(--color-surface)', borderRadius: 10, padding: '16px 20px' }}>
                                    <span style={{ flexShrink: 0, width: 8, height: 8, borderRadius: '50%', background: 'var(--color-primary)', marginTop: 7 }} />
                                    <span className="text-style" style={{ margin: 0 }}>
                                        <strong style={{ color: 'var(--color-primary)', display: 'block', marginBottom: 4 }}>{label}</strong>
                                        {body}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* ── TESTIMONIALS ── */}
                    <div className="card-pad" style={{ marginBottom: 0 }}>
                        <p style={{ fontSize: 11, fontWeight: 600, letterSpacing: '1.5px', textTransform: 'uppercase', opacity: 0.45, marginBottom: 16, display: 'flex', alignItems: 'center', gap: 6 }}>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
                            Testimonials
                        </p>
                        <h3 style={{ margin: '0 0 12px' }}>From the teams who use it.</h3>
                        <p className="text-style" style={{ marginBottom: 32 }}>
                            Real feedback from designers and developers across the product org — the people who adopted Dira and shaped it through everyday use.
                        </p>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 16 }}>
                            {[
                                {
                                    label: 'Developer',
                                    body: '"Handoffs are finally smooth — I get fewer design clarifications and can ship faster."',
                                },
                                {
                                    label: 'UI Designer',
                                    body: '"Ease of use and how easy delivery of projects has become. Consistent clean designs."',
                                },
                                {
                                    label: 'Product Designer',
                                    body: '"I saved hours each week because I don\'t have to reinvent basic patterns anymore."',
                                },
                            ].map(({ label, body }) => (
                                <div key={label} style={{ background: 'var(--color-surface)', borderRadius: 18, padding: '28px 24px', display: 'flex', flexDirection: 'column', gap: 16 }}>
                                    <p className="text-style" style={{ margin: 0, fontStyle: 'italic' }}>{body}</p>
                                    <p style={{ margin: 0, fontSize: 12, fontWeight: 600, opacity: 0.5, textTransform: 'uppercase', letterSpacing: '0.08em' }}>{label}</p>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* ── LEARNINGS ── */}
                    <div id="learnings" className="card-pad" style={{ marginBottom: 0 }}>
                        <p style={{ fontSize: 11, fontWeight: 600, letterSpacing: '1.5px', textTransform: 'uppercase', opacity: 0.45, marginBottom: 16 }}>
                            Lessons Learned
                        </p>
                        <h3 style={{ margin: '0 0 20px' }}>What this project reinforced.</h3>
                        <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: 12 }}>
                            {[
                                { label: 'A design system is not just components', body: 'It requires clear rules, governance, and ongoing communication to stay healthy and useful.' },
                                { label: 'Shared ownership is non-negotiable', body: 'When only one side drives the system, usage drops. Designers and developers need to co-own it.' },
                                { label: 'Early wins build trust', body: 'Starting with visible, high-impact fixes helped build momentum and buy-in across teams.' },
                                { label: 'Communication is as important as the system', body: 'Consistent training and updates matter as much as the components themselves.' },
                            ].map(({ label, body }) => (
                                <li key={label} style={{ display: 'flex', alignItems: 'flex-start', gap: 16 }}>
                                    <span style={{ flexShrink: 0, width: 8, height: 8, borderRadius: '50%', background: 'var(--color-primary)', marginTop: 7 }} />
                                    <div>
                                        <p style={{ fontFamily: 'var(--font-body)', fontWeight: 600, fontSize: 15, margin: '0 0 4px', color: 'var(--color-text)' }}>{label}</p>
                                        <p className="text-style" style={{ margin: 0, fontSize: 14 }}>{body}</p>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* ── THE TEAM ── */}
                    <div id="the-team" className="card-pad" style={{ marginBottom: 0 }}>
                        <h4 style={{ margin: '0 0 16px' }}>The Team</h4>
                        <FlexGroup>
                            <div>
                                <p className="text-style">
                                    Godfrey Kimani — Lead Product Designer<br />
                                    Alex Karanja — UX Lead<br />
                                    Stephen Maina — Tech Lead<br />
                                    Christopher Muiruri — Frontend Developer<br />
                                    Kelvin Mutiso — Product Designer
                                </p>
                            </div>
                            <div>
                                <p className="text-style">
                                    Nicholas Ochodo — UI Designer<br />
                                    Fredrick Juma — Product Designer<br />
                                    Rose Maina — iOS Developer<br />
                                    Zakayo Ngige — Android Developer
                                </p>
                            </div>
                        </FlexGroup>
                    </div>

                    {/* ── MORE CASE STUDIES ── */}
                    <div className="card-pad more-case-studies-wrap" style={{ marginBottom: 150 }}>
                        <h3 style={{ margin: '0 0 32px' }}>More case studies</h3>
                        <MoreCaseStudies />
                    </div>

                </ContentColumn>
            </PageLayout>

            <SiteFooter mode={mode} />

            {modal && (
                <div
                    onClick={() => setModal(null)}
                    style={{
                        position: 'fixed', inset: 0, zIndex: 9999,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        backdropFilter: 'blur(12px)', WebkitBackdropFilter: 'blur(12px)',
                        background: 'rgba(0,0,0,0.6)', padding: 24,
                        animation: 'fadeIn 0.2s ease',
                    }}
                >
                    <style>{`@keyframes fadeIn{from{opacity:0}to{opacity:1}} @keyframes scaleIn{from{opacity:0;transform:scale(0.88)}to{opacity:1;transform:scale(1)}}`}</style>
                    <div
                        onClick={e => e.stopPropagation()}
                        style={{
                            position: 'relative', maxWidth: '80vw', maxHeight: '80vh',
                            animation: 'scaleIn 0.25s cubic-bezier(0.34,1.56,0.64,1)',
                            background: modal.bg || 'transparent',
                            borderRadius: modal.bg ? 20 : 0,
                            padding: modal.bg ? 24 : 0,
                        }}
                    >
                        <img
                            src={modal.src}
                            alt="Expanded view"
                            style={{ display: 'block', maxWidth: '100%', maxHeight: modal.bg ? 'calc(80vh - 48px)' : '80vh', borderRadius: 12, boxShadow: modal.bg ? 'none' : '0 32px 80px rgba(0,0,0,0.5)', objectFit: 'contain' }}
                        />
                        <button
                            onClick={() => setModal(null)}
                            style={{ position: 'absolute', top: -16, right: -16, width: 36, height: 36, borderRadius: '50%', background: '#fff', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 12px rgba(0,0,0,0.25)', fontSize: 18 }}
                        >×</button>
                    </div>
                </div>
            )}
        </Main>
    );
};

export { Dira };
